import $ from 'jquery';

(($, Drupal, once) => {
  Drupal.behaviors.furuboda_megamenu = {
    attach: function() {
      $('.button--main-menu')
        // .once('button--main-menu')
        .each((index, element) => this.expandMainMenu(element));
      $('.menu-expand-arrow')
        // .once('menu-expand-arrow')
        .each((index, element) => this.expandSubMenu(element));
      $('.menu__level-0')
        // .once('menu__level-0')
        .each((index, element) => {
          this.focusTrap(element)
          this.setSubMenuId(element)
          this.escapeMenu(element)
        });
    },

    escapeMenu(element) {
      const KEYCODE_ESCAPE = 27;

      $(element).on('keyup', (e) => {
        if (e.defaultPrevented) {
          return;
        }

        if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === KEYCODE_ESCAPE) {

          const megamenu = document.getElementsByClassName('mega-menu');
          megamenu[0].classList.toggle('expanded');
        }

      })
    },

    expandMainMenu(element) {
      $(element).on('click', () => {
        const megamenu = document.getElementsByClassName('mega-menu');
        const menuIcon = document.getElementsByClassName('icon--menu');

        menuIcon[0].classList.toggle('menu--open');
        megamenu[0].classList.toggle('expanded');
        const activePage = megamenu[0].getElementsByClassName('is-active');
        const parentUl = activePage[0].closest('ul');

        if (parentUl.classList.contains('submenu')) {
          const parentMenu = parentUl.closest('li');
          const menuBtn = parentMenu.getElementsByTagName('button');
          menuBtn[0].classList.add('close-menu');
          parentUl.classList.toggle('expanded');
        }
      });
    },

    expandSubMenu(element) {
      $(element).on('click', (e) => {

        const parentBtn = e.target.closest('button');
        const controlId = parentBtn.getAttribute('aria-controls');
        const controlledSubmenu = document.getElementById(controlId);

        parentBtn.classList.toggle('close-menu');

        $('.submenu').not(controlledSubmenu).removeClass('expanded');
        $('button').not(parentBtn).removeClass('close-menu').removeAttr('aria-expanded')

        let ariaStatus = parentBtn.getAttribute('aria-expanded');
        if (ariaStatus == 'true') {
          ariaStatus = 'false'
        } else {
          ariaStatus = 'true'
        }

        controlledSubmenu.classList.toggle('expanded');
        parentBtn.setAttribute('aria-expanded', ariaStatus);
      });
    },

    focusTrap(element) {
      const focusableEls = element.querySelectorAll('a[href]:not([disabled])');
      const firstFocusableEl = focusableEls[0];
      const lastFocusableEl = focusableEls[focusableEls.length - 1];
      const KEYCODE_TAB = 9;

      element.addEventListener('keydown', (e) => {
        const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
          }
        }
        else {
          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      });
    },

    setSubMenuId(element) {
      const allSubmenus = document.querySelectorAll('.submenu');

      allSubmenus.forEach((submenu, index) => {
        const controlBtn = submenu.closest('li').getElementsByTagName('button');
        submenu.setAttribute('id', `submenu-${index}`);
        controlBtn[0].setAttribute('aria-controls', `submenu-${index}`)
      })
    }
  };
})(jQuery, Drupal, once);
